import { useAdminAuthStore } from '@/stores/admin/auth.js'

export default function adminRequireAuth(to, from, next) {
  const authStore = useAdminAuthStore()
  if (authStore.getToken) {
    next()
    return
  } else {
    next({
      path: '/admin/login',
      query: {
        redirect: localStorage.getItem('next_route_admin') ? localStorage.getItem('next_route_admin') : to.fullPath
      }
    })
    return
  }
}
